import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Tooltip } from 'antd';
import { UsedCustomField } from '../../../../../types/account_configurations';

interface ConfigurationUsedCustomFieldsProps {
  customFields: UsedCustomField[] | null;
}

const ConfigurationUsedCustomFields: React.FC<ConfigurationUsedCustomFieldsProps> = ({
  customFields,
}) => {
  const { t } = useTranslation();

  if (!customFields || customFields.length === 0) {
    return <span />;
  }

  if (customFields.length === 1) {
    return <Tag color="orange">{customFields[0].name}</Tag>;
  }

  return (
    <Tooltip
      title={
        <div>
          {customFields.map(field => (
            <div key={field.id}>{field.name}</div>
          ))}
        </div>
      }
    >
      <Tag color="orange">
        {customFields.length} {t('configurations:customFields')}
      </Tag>
    </Tooltip>
  );
};

export default ConfigurationUsedCustomFields;
